var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaperclipVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M5 4V10.5C5 12.433 6.567 14 8.5 14C10.433 14 12 12.433 12 10.5V3H14V10.5C14 13.5376 11.5376 16 8.5 16C5.46243 16 3 13.5376 3 10.5V4C3 1.79086 4.79086 0 7 0C9.20914 0 11 1.79086 11 4V10.5C11 11.8807 9.88071 13 8.5 13C7.11929 13 6 11.8807 6 10.5V4H8V10.5C8 10.7761 8.22386 11 8.5 11C8.77614 11 9 10.7761 9 10.5V4C9 2.89543 8.10457 2 7 2C5.89543 2 5 2.89543 5 4Z"
  })));
}

export default SvgPaperclipVertical;